import React from 'react';
import BusinessSolutionNav from './components/portal-nav/business-solution-nav';

const AppWrapper = ({ location, children }) => (
  <React.Fragment>
    <BusinessSolutionNav location={location} />
    {children}
  </React.Fragment>
);

export default AppWrapper;
